import { render, staticRenderFns } from "./modalEditPreviewText.vue?vue&type=template&id=2b52dc0e&"
import script from "./modalEditPreviewText.vue?vue&type=script&lang=js&"
export * from "./modalEditPreviewText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports